import { FC, memo } from 'react';
import { StatisticsV2 } from '../../components/StatisticsV2/StatisticsV2';
import { useStatisticsV2Screen } from '../../hooks/screens/useStatisticsV2Screen';

export const StatisticsV2Screen: FC = memo(() => {
  const props = useStatisticsV2Screen();

  return <StatisticsV2 {...props} />;
});

StatisticsV2Screen.displayName = 'StatisticsV2Screen';
